export default __webpack_public_path__ + "static/media/card-9.1135933e.png";